function refreshPage(path) {
  // alert(path)
  window.location.href = path;
  window.location.reload(false);
}
export const HandleLogout = () => {
  let role = sessionStorage.getItem('user_role')
  // console.log("logout role ",role)
  // alert(role)
  sessionStorage.removeItem('token');
  // sessionStorage.removeItem('user_role');
  sessionStorage.removeItem('user_id');
  sessionStorage.removeItem('username');
  if(role=='RESELLER'){
    refreshPage("/reseller/login");
  }
  else{
    refreshPage("/admin/login");
  }
  
};

//   try {
//     const response = await axios.request(PostMethod(`api/logout`));
//     if (response.data.status === "success") {
//       sessionStorage. removeItem();
//       refreshPage();
//       return;
//     }
//   } catch (error) {
//     if (
//       error.response.status === 401 ||
//       error.response.data.message === "Unauthenticated."
//     ) {
//       sessionStorage. removeItem();
//       refreshPage();
//       return;
//     }
//   }
